import "./AdditionalDetailsAddComponent.scss";
import * as Yup from "yup";
import React, {useCallback, useEffect, useState} from "react";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import {Field, FieldArray, FieldProps, Form, Formik, FormikHelpers} from "formik";
import FormikInputComponent from "../../../../shared/components/core/formik-input/FormikInputComponent";
import {Grid} from "@material-ui/core";
import {CommonService} from "../../../../shared/services";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddIcon from "@mui/icons-material/Add";
import {IAPIResponseType} from "../../../../shared/models/api.model";

interface AdditionalDetailsAddComponentProps {
    next: Function;
    cancel: Function;
    productId: number;
    productDetails: any;
    prev: Function;
}

const productInformationValidationSchema = Yup.object({

productCatalogLink: Yup.string().required('Required'),
        tagLine: Yup.string().required('Required'),
        methodOfCollection: Yup.mixed().required('Required'),
        resultingDays: Yup.string()
            .matches(/^\d+(\.\d+)?(-\d+(\.\d+)?)?$/, 'Please enter a valid number or range').required('Required')
            .test('is-positive', 'Please enter a positive number', (value) => value ? parseFloat(value) > 0 : false),
        analytes: Yup.array().of(Yup.object({
            analyte: Yup.string().required('Required'),
        })).required('Required'),
    }
);

interface productInformationFormSchema {
    productCatalogLink: string;
    tagLine: string;
    methodOfCollection: string;
    resultingDays: string;
    analytes: Array<{
        analyte: string;
    }>;

}

const productInformationInitialValues: productInformationFormSchema = {
    productCatalogLink: '',
    tagLine: '',
    methodOfCollection: '',
    resultingDays: '',
    analytes: [{
        analyte: '',
    }]
};


const AdditionalDetailsAddComponent = (props: AdditionalDetailsAddComponentProps) => {
    const {next, cancel,productId} = props;
    const [productDetailsInitialValues] = useState<productInformationFormSchema>(productInformationInitialValues);

    const onFormSubmit =  useCallback((values: productInformationFormSchema, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setSubmitting(true);
        const payload = {...values};
        payload.analytes = payload.analytes.map((analyte: any) => {
            return analyte.analyte;
        });
        setSubmitting(true);
        CommonService._inventory.addAdditionalDetails(productId,payload)
            .then((response: IAPIResponseType<any>) => {
                setSubmitting(false);
                next(response.data.id);
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            })
    },[next,productId]);

    return (
        <div className={'additional-details-add-component t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'Additional Details'}
                tooltipData={"Ensure that the name of the Facility is unique. By entering a ZIP Code, the state and city will be auto populated."}
                // handleClick={prev}
            />
            <div className="t-form">
                <Formik
                    validationSchema={productInformationValidationSchema}
                    initialValues={productDetailsInitialValues}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    onSubmit={onFormSubmit}
                >
                    {({isSubmitting, values, isValid, setFieldValue, validateForm, errors}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values]);
                        return (
                            // eslint-disable-next-line no-script-url
                            <Form noValidate={true} action={'javascript:void'}>
                                <div className={"t-form-controls-wrapper"}>
                                    <Field name={'productCatalogLink'}>
                                        {
                                            (field: FieldProps) => (
                                                <FormikInputComponent
                                                    label={'Product Catalog Link'}
                                                    placeholder={'Enter Product Catalog Link'}
                                                    type={"text"}
                                                    required={true}
                                                    formikField={field}
                                                />
                                            )}
                                    </Field>
                                    <Field name={'tagLine'}>
                                        {
                                            (field: FieldProps) => (
                                                <FormikInputComponent
                                                    label={'Product Tagline'}
                                                    placeholder={'Enter Product Tagline'}
                                                    type={"text"}
                                                    required={true}
                                                    formikField={field}
                                                />
                                            )}
                                    </Field>
                                    <Grid container spacing={2} xs={12}>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'methodOfCollection'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Select Collection Process'}
                                                            placeholder={'Select Collection Process'}
                                                            type={"text"}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    )}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>

                                            <Field name={'resultingDays'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Resulting Days'}
                                                            placeholder={'Enter Resulting Days'}
                                                            type={"text"}
                                                            required={true}
                                                            formikField={field}
                                                            suffix={'days'}
                                                        />
                                                    )}
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    <div className={'horizontal-line'}></div>
                                    <div className={'form-sub-title mrg-bottom-25'}>Test Analytes</div>
                                    <FieldArray name="analytes"
                                                render={(arrayHelpers: any) => (
                                                    <>
                                                        {values?.analytes && values?.analytes.map((analyte: any, index: any) => {
                                                            return (
                                                                <div key={index} className={''}>
                                                                    <Grid container spacing={2} xs={12}>
                                                                        <Grid item xs={12} sm={12} md={6}
                                                                              xl={6}>
                                                                            <Field
                                                                                name={`analytes[${index}].analyte`}>
                                                                                {
                                                                                    (field: FieldProps) => (
                                                                                        <FormikInputComponent
                                                                                            label={`Analyte Name`}
                                                                                            placeholder={`Enter Analyte Name`}
                                                                                            type={"text"}
                                                                                            required={true}
                                                                                            formikField={field}
                                                                                        />
                                                                                    )
                                                                                }
                                                                            </Field>
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={12} md={6}
                                                                              xl={6}>
                                                                            <ButtonComponent
                                                                                type="button"
                                                                                color={"error"}
                                                                                variant={"outlined"}
                                                                                className={'mrg-top-10'}
                                                                                fullWidth={false}
                                                                                startIcon={<RemoveCircleIcon/>}
                                                                                id="delete_icd_code_btn"
                                                                                handleClick={() => {
                                                                                    arrayHelpers.remove(index)
                                                                                    if (index === 0 && values?.analytes?.length === 1) {
                                                                                        arrayHelpers.push({analyte: ''})
                                                                                    }
                                                                                }}
                                                                            >
                                                                                Remove
                                                                            </ButtonComponent>
                                                                        </Grid>
                                                                    </Grid>
                                                                    {
                                                                        index === values?.analytes?.length - 1 && (
                                                                            <div className={''}>
                                                                                <ButtonComponent
                                                                                    type="button"
                                                                                    color={"secondary"}
                                                                                    variant={"text"}
                                                                                    fullWidth={false}
                                                                                    startIcon={<AddIcon/>}
                                                                                    id="add_analyte_btn"
                                                                                    handleClick={() => {
                                                                                        arrayHelpers.push({analyte: ''})
                                                                                    }}
                                                                                >
                                                                                    Add More
                                                                                </ButtonComponent>
                                                                            </div>)
                                                                    }
                                                                </div>
                                                            )

                                                        })
                                                        }
                                                    </>
                                                )}
                                    />
                                </div>
                                <div className="form-action-section">
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={true}
                                        disabled={isSubmitting}
                                        handleClick={cancel}
                                    >
                                        close
                                    </ButtonComponent>
                                    <ButtonComponent
                                        type="submit"
                                        color={"primary"}
                                        variant={"contained"}
                                        fullWidth={true}
                                        disabled={!isValid || isSubmitting}
                                        isLoading={isSubmitting}
                                    >
                                        Submit
                                    </ButtonComponent>
                                </div>
                            </Form>
                        )
                    }}
                </Formik>
            </div>
        </div>
    )
        ;

};

export default AdditionalDetailsAddComponent;
